import type { TranslationKeys } from './en';

const my: TranslationKeys = {
  // Common
  common: {
    loading: 'တင်နေသည်...',
    loadingMore: 'ထပ်တင်နေသည်...',
    reachedEnd: 'အပြီးသတ်ရောက်ရှိပြီ။',
    seeAll: 'အားလုံးကြည့်ရန်',
    viewAll: 'အားလုံးကြည့်ရန်',
    retry: 'ထပ်စမ်းကြည့်ရန်',
    clearFilters: 'ဖြစ်စီစစ်ဆေးမှုဖျက်ရန်',
    clearFilter: 'ဖြစ်စီစစ်ဆေးမှုဖျက်ရန်',
    all: 'အားလုံး',
    premium: 'ပရီမီယမ်',
    series: 'စီးရီး',
    views: 'ကြည့်ရှုမှု',
    eps: 'အပိုင်း',
    cancel: 'ပယ်ဖျက်ရန်',
  },

  // Navigation
  nav: {
    drama: 'ဒရာမာ',
    search: 'ရှာဖွေရန်',
    premium: 'ပရီမီယမ်',
  },

  // Header
  header: {
    notifications: 'အကြောင်းကြားချက်',
    profile: 'ပရိုဖိုင်',
  },

  // Home Page
  home: {
    genres: 'အမျိုးအစားများ',
    trendingNow: 'လတ်တလောရေပန်းစား',
    tagPicksFallback: 'သင့်အတွက်ရွေးချယ်ထားသည်',
    latest: 'နောက်ဆုံးပေါ်',
    latestSubtitle: 'တစ်ကြိမ်လျှင် ၂၀ ခုဖြင့် အဆက်မပြတ်ရွှေ့ရန်။',
    loadedOf: '{{total}} တွင် {{current}} ပြပြီး',
    play: 'ကြည့်ရှုရန်',
    details: 'အသေးစိတ်',
    noLatestBoxes: 'နောက်ဆုံးပေါ်ရလဒ်များမတွေ့ပါ။',
  },

  // Search Page
  search: {
    placeholder: 'ရုပ်ရှင်၊ အမျိုးအစား ရှာဖွေရန်...',
    noResults: 'ရလဒ်မတွေ့ပါ',
    tryDifferent: 'စကားလုံးကွဲပြားစွာ ရှာဖွေကြည့်ပါ',
    browseCollection: 'ကျွန်ုပ်တို့၏စုစည်းမှုကို ကြည့်ရှူပါ သို့မဟုတ် အခြားအမျိုးအစားစမ်းကြည့်ပါ',
    results: 'ရလဒ် {{count}} ခု',
    zeroResults: 'ရလဒ် ၀',
    ofTotal: ' စုစုပေါင်း {{total}}',
    noBoxesFound: 'ရလဒ်များမတွေ့ပါ။',
  },

  // Profile Page
  profile: {
    title: 'ပရိုဖိုင်',
    episodesWatched: 'ကြည့်ပြီးတွဲအရေအတွက်',
    coinsBalance: 'ငွေစာရင်းလက်ကျန်',
    watchlist: 'ကြည့်ရှုစာရင်း',
    account: 'အကောင့်',
    userInformation: 'အသုံးပြုသူအချက်အလက်',
    userInfoDesc: 'အမည်၊ အီးမေးလ်၊ စကားဝှက်',
    transactionHistory: 'ငွေစာရင်းမှတ်တမ်း',
    transactionDesc: 'ဝယ်ယူမှုနှင့် ငွေသုံးစွဲမှု',
    subscriptionPlans: 'စားသုံးသူအစီအစဉ်',
    subscriptionDesc: 'အစီအစဉ်စီမံခန့်ခွဲရန်',
    signOut: 'ထွက်ရန်',
    footer: 'MMBox v1.0.0• စည်းမျဉ်းနှင့် ကိုယ်ရေးအချက်အလက်',
    termsAndPrivacy: 'စည်းမျဉ်းနှင့် ကိုယ်ရေးအချက်အလက်',
    language: 'ဘာသာစကား',
    languageDesc: 'ပြသမည့်ဘာသာစကားပြောင်းရန်',
    english: 'English',
    burmese: 'မြန်မာ',
    telegramUser: 'Telegram အသုံးပြုသူ',
  },

  // Purchase Page
  purchase: {
    title: 'ကျွန်ုပ်ဝယ်ယူမှုများ',
    items: '{{count}} ခု',
    noPurchases: 'ဝယ်ယူမှုမရှိသေးပါ',
    failedToLoad: 'ဝယ်ယူမှုများတင်၍မရပါ',
  },

  // Notification Page
  notification: {
    title: 'အကြောင်းကြားချက်များ',
    unreadOnly: 'ဖတ်မပြီးသား',
    all: 'အားလုံး',
    loading: 'အကြောင်းကြားချက်များတင်နေသည်...',
    failedToLoad: 'အကြောင်းကြားချက်များတင်၍မရပါ။',
    noUnread: 'ဖတ်မပြီးသော အကြောင်းကြားချက်များမရှိပါ',
    noNotifications: 'အကြောင်းကြားချက်များမရှိသေးပါ',
    loadMore: 'ထပ်တင်ရန်',
    justNow: 'ယခုအချိန်',
    minAgo: '{{count}} မိနစ်အကြာ',
    hourAgo: '{{count}} နာရီအကြာ',
    dayAgo: '{{count}} ရက်အကြာ',
  },

  // Transaction Page
  transaction: {
    title: 'ငွေစာရင်းမှတ်တမ်း',
    count: '{{count}} ငွေစာရင်း',
    noTransactions: 'ငွေစာရင်းမရှိသေးပါ',
    failedToLoad: 'ငွေစာရင်းများတင်၍မရပါ',
    purchase: 'ဝယ်ယူမှု',
    subscription: 'စားသုံးသူအစီအစဉ်',
    refund: 'ပြန်လည်ပေးအပ်မှု',
    topUp: 'ငွေဖြည့်သွင်းမှု',
    boxPurchase: 'ဘောက်စဝယ်ယူမှု',
    completed: 'ပြီးမြောက်',
    active: 'အသက်ဝင်နေ',
    pending: 'စောင့်ဆိုင်းနေ',
    failed: 'မအောင်မြင်',
    cancelled: 'ပယ်ဖျက်ပြီး',
    filterByStatus: 'အခြေအနေအလိုက် စီစစ်ရန်',
    allStatuses: 'အခြေအနေအားလုံး',
    transactionLabel: 'ငွေစာရင်း',
  },

  // Movie Detail
  movieDetail: {
    invalidId: 'ရုပ်ရှင်အိုင်ဒီမမှန်ကန်ပါ။',
    failedToLoad: 'ရုပ်ရှင်အသေးစိတ်တင်၍မရပါ။',
    epsFree: 'အခမဲ့ {{count}} ပိုင်း',
    allEpisodes: 'စုစုပေါင်း {{count}} ပိုင်း',
    seeMore: 'ပိုမိုကြည့်ရှုရန်',
    playFree: 'အခမဲ့အပိုင်း များကို ယခုကြည့်ရှုရန်',
    sending: 'ပို့နေသည်...',
    signInToUnlock: 'အကောင့်ဖွင့်ရန် ဝင်ရောက်ပါ',
    unlockEpisodes: '{{count}} ပိုင်းကို ထပ်ကြည့်ရန်',
    signingIn: 'ဝင်ရောက်နေသည်...',
    youOwnThis: 'သင်ဝယ်ပြီးပါပြီ',
    watchNow: 'ယခုကြည့်ရှုရန်',
    processing: 'ဆောင်ရွက်နေသည်...',
    playbackFailed: 'ပြသမှုမအောင်မြင်: {{error}}',
  },

  // Episode Select
  episodeSelect: {
    title: 'အပိုင်း ရွေးချယ်ရန်',
    subtitle: 'Telegram သို့ပို့ရန် အပိုင်းများရွေးချယ်ပါ',
    selectAll: 'အားလုံးရွေးရန်',
    deselectAll: 'အားလုံးပယ်ရန်',
    loading: 'အပိုင်း များတင်နေသည်...',
    failedToLoad: 'အပိုင်းများတင်၍မရပါ။',
    ep: 'အပိုင်း',
    sending: 'ပို့နေသည်...',
    sendToTelegram: 'Telegram သို့ {{count}} အပိုင်းပို့ရန်',
    episodesAvailable: '{{count}} အပိုင်းရရှိနိုင်',
    selectedCount: '{{total}} တွင် {{selected}} ပိုင်း ရွေးချယ်ပြီး',
  },

  // Watch Modal
  watchModal: {
    loadingVideo: 'ဗီဒီယိုတင်နေသည်...',
    unableToPlay: 'ပြသ၍မရပါ',
    tryAgain: 'ထပ်စမ်းကြည့်ရန်',
  },

  // Not Found Page
  notFound: {
    title: 'စာမျက်နှာမတွေ့ပါ',
    description: 'ရှာဖွေနေသော စာမျက်နှာမရှိပါ သို့မဟုတ် ရွှေ့ပြောင်းထားပါသည်။',
    goHome: 'ပင်မသို့သွားရန်',
    browseContent: 'အကြောင်းအရာကြည့်ရန်',
  },

  // Vertical Box List
  boxList: {
    noDescription: 'ဖော်ပြချက်မရှိပါ။',
  },

  // Premium Modal
  premium: {
    premiumContent: 'ပရီမီယမ်အကြောင်းအရာ',
    episodeInfo: 'စုစုပေါင်း {{total}} ပိုင်း ({{free}} အခမဲ့၊ {{locked}} ပိတ်ထား)',
    totalPrice: 'စုစုပေါင်းစျေး',
    unlockAllEpisodes: 'ဝယ်ယူမှုတစ်ခုဖြင့် အပိုင်းအားလုံးကိုဖွင့်ပါ',
    buyNow: 'ယခုဝယ်ရန်',
    processing: 'ဆောင်ရွက်နေသည်...',
  },

  // Routes fallback
  routes: {
    loading: 'တင်နေသည်...',
  },

  // Terms and Conditions
  terms: {
    title: 'စည်းမျဉ်းများ',
    back: 'နောက်သို့',
    updated: 'နောက်ဆုံးပြင်ဆင်သည့်ရက်: ဧပြီ 2026',
    intro:
      'MMBox ကိုအသုံးပြုခြင်းအားဖြင့် ဤစည်းမျဉ်းများကို လိုက်နာရန် သဘောတူပါသည်။ ဆက်လက်အသုံးပြုမီ သေချာဖတ်ရှုပါ။',
    sec1Title: '1. အကောင့်နှင့် အသုံးပြုခွင့်',
    sec1Body:
      'သင့်အကောင့်နှင့် သုံးစွဲမှုအားလုံးအတွက် သင့်တွင် တာဝန်ရှိပါသည်။ Premium အခွင့်အရေးနှင့် ဝယ်ယူထားသောအကြောင်းအရာများသည် သင့်အကောင့်နှင့်ချိတ်ဆက်ထားပါသည်။',
    sec2Title: '2. အကြောင်းအရာအသုံးပြုမှု',
    sec2Body:
      'MMBox ရှိ ဗီဒီယိုနှင့် မီဒီယာများကို ကိုယ်ပိုင်ကြည့်ရှုရန်သာ အသုံးပြုနိုင်ပါသည်။ ခွင့်ပြုချက်မရှိဘဲ ဖြန့်ဝေခြင်း သို့မဟုတ် စီးပွားရေးအသုံးပြုခြင်း မပြုလုပ်ရပါ။',
    sec3Title: '3. ဝယ်ယူမှုနှင့် ပြန်အမ်းငွေ',
    sec3Body:
      'Premium အကြောင်းအရာ ဝယ်ယူမှုများကို လုံခြုံသောပေးချေမှုစနစ်များမှ တစ်ဆင့် ဆောင်ရွက်ပါသည်။ ဥပဒေအရလိုအပ်သည့်ကိစ္စများမှအပ ပြီးစီးပြီးသောဝယ်ယူမှုများကို ပုံမှန်အားဖြင့် မပြန်အမ်းပါ။',
    sec4Title: '4. ပြင်ဆင်မှုများ',
    sec4Body:
      'MMBox ၏ လုပ်ဆောင်ချက်များ၊ စျေးနှုန်းများ သို့မဟုတ် ဤစည်းမျဉ်းများကို အချိန်မရွေး ပြင်ဆင်နိုင်ပါသည်။ ပြင်ဆင်ပြီးနောက် ဆက်လက်အသုံးပြုပါက စည်းမျဉ်းအသစ်များကို လက်ခံသည်ဟု မှတ်ယူပါသည်။',
  },
};

export default my;
